<template>
  <div v-show="measureOpen" class="customMenuDiv">
    <v-card width="300" color="white">
      <v-toolbar color="#003366" dark>
        <v-toolbar-title>{{getTitleText}}</v-toolbar-title>
        <v-spacer></v-spacer>
          <v-tooltip top>
            <v-btn slot="activator" icon @click="stopMeasuring">
              <v-icon>close</v-icon>
            </v-btn>
            <span>Stop Measuring</span>
          </v-tooltip>
      </v-toolbar>

      <v-layout v-if="getMeasureDialog" align-center row 
        class="mt-2 ml-3 subheading text-xs-left font-weight-medium">
        <v-flex xs6 >
          <template v-if="getMeasuredVals " >
            <template v-for="line in getMeasuredVals.split(',')">{{line}}<br>
              <!-- <v-spacer :key="line"></v-spacer> -->
            </template>
          </template> 
        </v-flex>
        <v-flex xs6 class="ml-3 mr-4" style="position: relative; top:2px;">
          <v-select
              :value="getMeasureSelect"
              @change="changeMeasureUnit"
              pt-0
              :items="getMeasrureOptions"
              item-text="text"
              item-value="val"
            ></v-select>
          </v-flex>
      </v-layout>

        <v-list class="ml-2">

          <v-list-tile 
              ripple              
              active-class="fattile subheading" 
              @click.stop="measure('measure-length')"
              class="fattile"
              :class="currentTool == 'measure-length' ? 'activeTile' : ''"
              >
            <v-layout fill-height align-center>
              <v-flex xs4>
                <v-btn right color="indigo" fab small dark >
                  <v-icon dark>timeline</v-icon>
                </v-btn>
              </v-flex>
              <v-flex xs8>
                <span class="heading">Measure Distance</span>
                </v-flex>
            </v-layout>
          </v-list-tile>

          <v-list-tile 
              ripple
              @click.stop="measure('measure-location')" 
              class="fattile"
              :class="currentTool == 'measure-location' ? 'activeTile' : ''">
            <v-layout fill-height align-center>
              <v-flex xs4>
                <v-btn right color="indigo" fab small dark >
                  <v-icon small dark>fiber_manual_record</v-icon>
                </v-btn>
              </v-flex>
              <v-flex>
                <span class="heading">Get Coordinates</span>
              </v-flex xs8>
            </v-layout>
          </v-list-tile>

          <v-list-tile 
              ripple
              @click.stop="measure('measure-area')" 
              class="fattile"
              :class="currentTool == 'measure-area' ? 'activeTile' : ''">
            <v-layout fill-height align-center>
              <v-flex xs4>
                <v-btn right color="indigo" fab small dark >
                  <v-icon dark>signal_cellular_null</v-icon>                  
                </v-btn>
              </v-flex>
              <v-flex xs8>
                <span class="heading">Measure Area</span>
                </v-flex>
            </v-layout>
          </v-list-tile>

        </v-list>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";

export default {
  data() {
    return {
      menu: false,
    };
  },

  methods: {
    ...mapActions(['deactivateMeasureTB']),
    ...mapMutations(['showMeasure','SET_MEASURE_DIALOG' ]),

    measure: function(tool) {
      let store = this.$store;

      // Reset measureOptionsSelect to clean existing geometry type selection
      store.commit("SET_MEASURE_SELECT", {});
      store.dispatch("activateMeasure", tool);
      store.commit('setCurrentTool', tool);
      store.commit("SET_MEASURED_VALS", null);
      this.$store.commit("SET_MEASURE_DIALOG", false);
    },

    dialogVisiblity: function() {
      console.log("hide dialogVisibility...!");
      this.$store.dispatch("deactivateMeasureTB");
      this.$store.commit("SET_MEASURE_DIALOG", !this.getMeasureDialog);
    },
    changeMeasureUnit: function(val) {
      //console.log("value is :: "+val +", search in ::");
      //console.log(JSON.stringify(this.getMeasrureOptions));
      var resultObject = this.searchArray(val, this.getMeasrureOptions)
      this.$store.commit("SET_MEASURE_SELECT", resultObject)
      this.$store.dispatch("measureChange", resultObject)      
    },

    searchArray: function (nameKey, myArray) {
      for (var i = 0; i < myArray.length; i++) {
        if (myArray[i].val === nameKey) {
          return myArray[i];
        }
      }
    },

    stopMeasuring: function () {
      if (this.measureOpen) { this.clearGraphics() }
      this.showMeasure(false)
      this.deactivateMeasureTB()
      this.deactivateMeasureTB()
      this.SET_MEASURE_DIALOG(false)
    }
  },

  computed: {
    ...mapGetters({
      getMeasureDialog: "getMeasureDialog",
      getMeasrureOptions: "getMeasrureOptions",
      getMeasureSelect: "getMeasureSelect",
      getMeasuredVals: "getMeasuredVals",
      measureOptionsVisible: "measureOptionsVisible",
      getMeasureScreenExtent: "getMeasureScreenExtent"
    }),

    ...mapState({
      measureOpen: state => state.ui.measureOpen,
      currentTool: state => state.measurement.currentTool,
      clearGraphics: state => state.mapFunctions.clearGraphics
    }),

    getTitleText: function () {
      //console.log(this.currentTool)
      if (this.currentTool == "measure-length") return "Measuring Length"
      if (this.currentTool == "measure-area") return "Measuring Area"
      if (this.currentTool == "measure-location") return "Get Coordinates"
    },
  }
};
</script>

<style>

.fattile > .v-list__tile {
    height: 60px;
    padding-left: 15px;
    padding-top: 1px;
}

.activeTile {
  background-color: lightgrey;
}

.btnMeasure {
  z-index: 1;
}

.customMenu {
  display: contents !important;
}

.customMenuDiv {
position: absolute;

    bottom: 6%;
    right: 50px;
}

.measureDailog {
  position: absolute;
  left: 23px;
  bottom: 59px;
}
.custom {
  white-space: pre-wrap;
}
</style>






// WEBPACK FOOTER //
// src/components/measureButton.vue